import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const missionTimeAction = createAsyncThunk(
    'mission-time',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.post(`/admins/api/mission-active-time`, { ...data })
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const missionTimeSlice = createSlice({
    name: 'mission-time',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(missionTimeAction.pending, (state) => {
                state.data = []
                state.loading = true
            })
            builder.addCase(missionTimeAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(missionTimeAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const missionTimeReducer = missionTimeSlice.reducer